module.exports = __webpack_public_path__ + "img/costa.b40db743.jpg";